<template>
<div class="chapter">
<div class="inner_page">
<p class="title">MASTER</p>
<p class="title1">AMERICAN<br/>HISTORY</p>
<p class="pub1"><img alt="image" src="images/img3.jpg"/></p>
<p class="author1">DAN ROBERTS</p>
<p class="author2">Professor of Liberal Arts and History<br/>Chair, Department of Liberal Arts<br/>School of Professional and Continuing Studies<br/>University of Richmond<br/>Executive Producer and Host, A <i>Moment in Time</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6c544651